import { cloneElement, forwardRef, ReactElement } from "react";
import { useClientEvents } from "hooks/use-client-events";
import { useImpression } from "hooks/use-impression";
import { useSearchQuery } from "hooks/use-search";
import { useTrackingRef } from "hooks/use-tracking-ref";
import { IMPRESSION_MIN_VISIBLE_MS, IMPRESSION_MIN_VISIBLE_RATIO } from "./thresholds";

interface IProps {
    productId: number;
    // Must forward its ref to a DOM element
    children: ReactElement;
}

export const ProductImpression = forwardRef<HTMLElement, IProps>(({ productId, children }, forwardedRef) => {
    const [ref, mergedRef] = useTrackingRef(forwardedRef);
    const query = useSearchQuery();
    const { addEvent } = useClientEvents();

    useImpression(ref, {
        minVisibleRatio: IMPRESSION_MIN_VISIBLE_RATIO,
        minVisibleMs: IMPRESSION_MIN_VISIBLE_MS,
        onImpression: () => addEvent({ type: "PRODUCT_IMPRESSION", refId: String(productId), payload: { query } }),
    });

    return cloneElement(children, { ref: mergedRef });
});
ProductImpression.displayName = "ProductImpression";
